import { render, staticRenderFns } from "./vehiclePicture.vue?vue&type=template&id=6f8734b6&scoped=true&"
import script from "./vehiclePicture.vue?vue&type=script&lang=js&"
export * from "./vehiclePicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8734b6",
  null
  
)

export default component.exports